import {
  getListOfCities,
  getListOfCountries,
  getListOfStates,
} from 'modules/Auth/actions'
import authSelector from 'modules/Auth/selectors'
import {
  fileUpload,
  getNewDriveFreshersList,
  getNewDriveScore,
  getNewDriveStatus,
  getNewIndividualDriveStatus,
  getPanelList,
} from 'modules/Drives/actions'
import {
  default as driveSelectors,
  default as newDriveSelector,
} from 'modules/Drives/selectors'
import ViewIndividualDrive from 'modules/Exp-Candidates/ViewDriveRole/index'
import {
  addInterviewer,
  createInterview,
  deleteInterviewer,
  getCandidateDocumentsList,
  getCandidateScoreList,
  getCities,
  getDegreeAndDepartMent,
  getDriveInterviewerList,
  getDriveRoleCandidatesList,
  getDriveRoleMetrics,
  getGroupCandidateList,
  getGroupDiscussionList,
  getIndidualDriveData,
  getInterViewLocation,
  getInterviewerList,
  getRequestDocument,
  getRoleMetrics,
  getRoleRounds,
  getSingleCandidateInterviewDetails,
  getTopicsList,
  getcollegeList,
  postPassingScore,
  postShortlistCandidates,
  releaseOfferAPI,
  requestCandidateDocuments,
  updateInterview,
  updateInterviewStatus,
  updateRoleRounds,
} from 'modules/Exp-Candidates/actions'
import driveSelector from 'modules/Exp-Candidates/selectors'
import { getCandidateDetails, getSingleRoleData } from 'modules/Roles/actions'
import rolesSelectors from 'modules/Roles/selectors'
import {
  addCorporateBranch,
  deleteLocationAPI,
  getCorporateLocationsList,
  getLocationDetails,
  updateLocationAPI,
} from 'modules/Settings/actions'
import settingsSelector from 'modules/Settings/selectors'
import { connect } from 'react-redux'
import { getCandidateDocumentsMetrices } from '../../Drives/actions'

const mapStateToProps = state => ({
  driveRolesMetrics: driveSelector.getDriveRoleMetrics(state),
  rolesMetrics: driveSelector.getRoleMetrics(state),
  degreeList: driveSelector.getDegreeList(state),
  driveData: driveSelector.getDriveData(state),
  driveInterViewerList: driveSelector.getDriveInterViewerList(state),
  interViewerList: driveSelector.getInterViewerList(state),
  collegeList: driveSelector.getCollegeList(state),
  candidateDetails: rolesSelectors.getCandidateDetails(state),
  candidateInterviewDetails: driveSelector.getCandidateInterviewDetails(state),
  groupList: driveSelector.getGroupList(state),
  groupCandidateList: driveSelector.getGroupCandidateList(state),
  cityList: driveSelector.getCityList(state),
  singleRoleData: rolesSelectors.getSingleRoleData(state),
  roleRoundsList: driveSelector.getRoleRoundsList(state),
  requestDocumentList: driveSelector.getRequestDocumentlist(state),
  interViewdata: driveSelector.getInterViewLocation(state),
  singleLocationData: settingsSelector.getSingleLocationData(state),
  listOfCountries: authSelector.getListOfCountries(state),
  listOfStates: authSelector.getListOfStates(state),
  listOfCities: authSelector.getListOfCities(state),
  corporateLocationsList: settingsSelector.getCorporateLocations(state),
  canditateDocumentList: driveSelectors.getCandidateDocumentsList(state),
  canditateDocumentMetrices:
    driveSelectors.getCandidateDocumentsMetrices(state),
  newFreshersListData: newDriveSelector.getFreshersList(state),
  newDriveStatusData: newDriveSelector.getNewDriveStatus(state),
  newDriveScoreData: newDriveSelector.getNewDriveScore(state),
  newDriveScore: newDriveSelector.getNewDriveMetrics(state),
  newDriveMetrics: newDriveSelector.getNewDriveMetrics(state),
})

const mapDispatchToProps = {
  getDriveRoleMetrics,
  getDriveRoleCandidatesList,
  getRoleMetrics,
  getDegreeAndDepartMent,
  getIndidualDriveData,
  createInterview,
  updateInterview,
  getDriveInterviewerList,
  getcollegeList,
  getCandidateDetails,
  getSingleCandidateInterviewDetails,
  getGroupDiscussionList,
  getGroupCandidateList,
  addInterviewer,
  deleteInterviewer,
  updateInterviewStatus,
  getCities,
  getInterviewerList,
  releaseOfferAPI,
  getSingleRoleData,
  getRoleRounds,
  updateRoleRounds,
  requestCandidateDocuments,
  getRequestDocument,
  getInterViewLocation,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  getLocationDetails,
  updateLocationAPI,
  deleteLocationAPI,
  getCorporateLocationsList,
  addCorporateBranch,
  getCandidateDocumentsList,
  getCandidateDocumentsMetrices,
  fileUpload,
  getCandidateScoreList,
  postShortlistCandidates,
  getTopicsList,
  postPassingScore,
  getNewIndividualDriveStatus,
  getPanelList,
  getNewDriveFreshersList,
  getNewDriveStatus,
  getNewDriveScore,
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewIndividualDrive)
